const CatalogContainersConstants = {
        STATUSBAR_CONTAINER_ID: 'catalog-statusbar',
        STATUSBAR_MOBILE_CONTAINER_ID: 'catalog-statusbar-mobile',
        NOTIFY_ME_CONTAINER_ID: 'catalog-notify-me',
        CATALOG_ITEMS_CONTAINER_ID: 'catalog-items',
        CATALOG_ITEMS_REVAMP_CONTAINER_ID: 'catalog-items-revamp',
        CATALOG_PROMOTIONS_CONTAINER_ID: 'catalog-promotions-container',
        CATALOG_PROMOTIONS_REVAMP_CONTAINER_ID: 'catalog-promotions-container-revamp',
        CATALOG_ADS_CONTAINER_ID: 'catalog-ads-container',
        CATALOG_REVAMP_ADS_CONTAINER_ID: 'catalog-revamp-ads-container',
        CATALOG_FILTER_TRAY_ID: 'catalog-filter-tray',
        CATALOG_FILTER_TRAY_ID_STICKY: 'catalog-filter-tray-sticky',
        CATALOG_UI_LOCK_CONTAINER_ID: 'catalog-ui-lock',
        FRIENDBUY_LIGHT_BOX_CONTAINER_ID: 'friendbuy-light-box',
        FREE_MOBILE_FITTING_LIGHT_BOX_CONTAINER_ID: 'free-mobile-fitting-light-box',
        CATALOG_FILTERS_COLUMN_CONTAINER_ID: 'catalog-filters-column',
        CONFIGURATOR_CONTAINER_ID: 'configurator',
        VEHICLE_CONFIGURATOR_CONTAINER_ID: 'vehicle-configurator',
        REGO_LOOKUP_CONFIGURATOR_CONTAINER_ID: 'rego-lookup-configurator',
        TYRE_INDEX_EXPLANATION_LIGHTBOX_CONTAINER_ID: 'tyre-index-explanation-lightbox',
        CATALOG_FILTERS_LIGHTBOX_CONTAINER_ID: 'catalog-filters-lightbox',
        CATALOG_SHIPPING_QUOTE_CONTAINER_ID: 'catalog-shipping-quote-lightbox',
        CATALOG_DELIVERY_INFO_LIGHT_BOX_CONTAINER_ID: 'catalog-delivery-info-lightbox',
        PRODUCT_MIXED_STOCKS_APP_CONTAINER_ID: 'product-mixed-stocks',
        CMS_ADS_CONTAINER_ID: 'cms-ads-product',
    }
;

export default CatalogContainersConstants;